export const allPlansData = [
  {
    id: 0,
    label: "Regular Plan",
    icon: "fi fi-sr-megaphone",
    link: "regularplan",
    description:
      "A regular campaign plan for DOOH media offers a flexible and comprehensive approach, allowing advertisers to target audiences based on demographics, behaviors, and locations while selecting DOOH inventory near key store locations. This plan also provides the option to incorporate triggers such as weather, time of day, or traffic conditions to enhance relevance and engagement. By combining audience targeting, strategic location selection, and real-time triggers, advertisers can optimize reach, impact, and campaign performance efficiently.",
    color: "#8B5CF6",
  },
  {
    id: 1,
    label: "I Know It All Plan",
    icon: "fi fi-sr-head-side-brain",
    link: "iknowitallplan",
    description: `An "I Know It All" campaign plan for DOOH media is designed for advertisers who have precise knowledge of the DOOH inventory they want to target. This plan involves selecting specific screens or locations based on audience insights, historical performance, or strategic brand positioning. Since the advertiser controls the placements, the campaign can be optimized for maximum impact by choosing the best time slots, locations, and content variations. This approach ensures efficient budget allocation and a high return on investment by delivering ads exactly where and when they matter most`,
    color: "#3B82F6",
  },
  {
    id: 2,
    label: "Topical Day Plan",
    icon: "fi fi-sr-calendar-star",
    link: "specialdayplan",
    description:
      "A special day campaign plan for DOOH media is a one-day advertising strategy designed to maximize impact on a specific occasion, such as a holiday, product launch, or major event. Ads are scheduled to appear at high-traffic locations and peak times, leveraging dynamic content, countdowns, or real-time updates to create urgency and engagement. By focusing on a single day, this campaign ensures high visibility and relevance, driving awareness, foot traffic, or immediate action from the target audience.",
    color: "#F59E0B",
  },
  {
    id: 3,
    label: "Trigger Based Plan",
    icon: "fi fi-sr-condition-alt",
    link: "triggerbasedplan",
    description:
      "A trigger-based campaign plan for DOOH (Digital Out-of-Home) media involves dynamically activating ads based on real-time conditions or predefined triggers. These triggers can include factors such as weather changes, audience demographics, traffic patterns, time of day, or external data feeds (e.g., sports scores or stock market updates). By leveraging data-driven automation, advertisers can ensure that their messages appear at the most relevant moments, maximizing engagement and campaign effectiveness while optimizing ad spend",
    color: "#22C55E",
  },
  {
    id: 4,
    label: "Store Based Plan",
    icon: "fi fi-sr-shop",
    link: "storebasedplan",
    description:
      "A store location-based campaign plan for DOOH media focuses on delivering ads near specific retail locations to drive foot traffic and conversions. These campaigns use geo-fencing and audience data to target screens within a defined radius of a store, triggering relevant ads based on proximity, time of day, or consumer behavior. This approach ensures that potential customers see compelling offers or promotions when they are most likely to visit, enhancing engagement and optimizing ad effectiveness",
    color: "#EF4444",
  },
];

export const regularPlanData = [
  {
    id: 1,
    value: "Basic Details Page",
  },
  {
    id: 2,
    value: "Audience And TouchPoint Page",
  },
  {
    id: 3,
    value: "Advance Filter Page",
  },
  {
    id: 4,
    value: "Compare Plan Page",
  },
  {
    id: 5,
    value: "Screen Summary Page",
  },
  {
    id: 6,
    value: "Add Triggers Page",
  },
  {
    id: 7,
    value: "View Final Plan Page",
  },
  {
    id: 8,
    value: "Upload Creative Page",
  },
  {
    id: 9,
    value: "Vendor Confirmation Page",
  },
  {
    id: 10,
    value: "Campaign Dashboard Page",
  },
];

export const iKnowItAllPlanData = [
  {
    id: 1,
    value: "Basic Details Page",
  },
  {
    id: 2,
    value: "Select Screens Page",
  },
  {
    id: 3,
    value: "Set Ad Play time Page",
  },
  {
    id: 4,
    value: "Screen Summary Page",
  },
  {
    id: 5,
    value: "View Final Plan Page",
  },
  {
    id: 6,
    value: "Upload Creative Page",
  },
  {
    id: 7,
    value: "Vendor Confirmation Page",
  },
];

export const specialDayPlanData = [
  {
    id: 1,
    value: "Basic Details Page",
  },
  {
    id: 2,
    value: "Audience And TouchPoint Page",
  },
  {
    id: 3,
    value: "Advance Filter Page",
  },
  {
    id: 4,
    value: "Compare Plan Page",
  },
  {
    id: 5,
    value: "Screen Summary Page",
  },

  {
    id: 6,
    value: "View Final Plan Page",
  },
  {
    id: 7,
    value: "Upload Creative Page",
  },
  {
    id: 8,
    value: "Vendor Confirmation Page",
  },
];

export const storeBasePlanData = [
  {
    id: 1,
    value: "Basic Details Page",
  },
  {
    id: 2,
    value: "Advance Filter Page",
  },
  {
    id: 3,
    value: "Select Screens Page",
  },
  {
    id: 4,
    value: "Set Ad Play time Page",
  },
  {
    id: 5,
    value: "Screen Summary Page",
  },
  {
    id: 6,
    value: "View Final Plan Page",
  },
  {
    id: 7,
    value: "Upload Creative Page",
  },
  {
    id: 8,
    value: "Vendor Confirmation Page",
  },
];

export const triggerBasePlanData = [
  {
    id: 1,
    value: "Basic Details Page",
  },
  {
    id: 2,
    value: "Add Triggers Page",
  },
  {
    id: 3,
    value: "Audience And TouchPoint Page",
  },
  {
    id: 4,
    value: "Advance Filter Page",
  },
  {
    id: 5,
    value: "Compare Plan Page",
  },
  {
    id: 6,
    value: "Screen Summary Page",
  },
  {
    id: 7,
    value: "View Final Plan Page",
  },
  {
    id: 8,
    value: "Upload Creative Page",
  },
  {
    id: 9,
    value: "Vendor Confirmation Page",
  },
];

export const EditCreativeData = [
  {
    id: 1,
    value: "Upload Creative Page",
  },
  {
    id: 2,
    value: "Vendor Confirmation Page",
  },
];